import { render } from "./BroadcastManagePanel.vue?vue&type=template&id=75784226"
import script from "./BroadcastManagePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastManagePanel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/BroadcastManagePanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75784226"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75784226', __exports__)) {
    api.reload('75784226', __exports__)
  }
  
  module.hot.accept("./BroadcastManagePanel.vue?vue&type=template&id=75784226", () => {
    api.rerender('75784226', render)
  })

}


export default __exports__